import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { Vehicle, VehicleDerivative } from '@/features/vehiclesearch';
import { agreementCheckIdentity } from '../utils/agreementCheckIdentity';
import { existingAgreementCheckKey } from './useExistingAgreementCheck';

type SelectableVehicle = Vehicle | VehicleDerivative;

const identityKey = (vehicle: SelectableVehicle | null): string | null => {
    const identity = agreementCheckIdentity(vehicle);
    return identity === null ? null : JSON.stringify(existingAgreementCheckKey(identity));
};

export function useSeenAgreementCheck(selectedVehicle: SelectableVehicle | null) {
    const queryClient = useQueryClient();
    const [seenKey, setSeenKey] = useState<string | null>(null);

    const recordSelection = (vehicle: SelectableVehicle) => {
        const identity = agreementCheckIdentity(vehicle);
        const settled =
            identity !== null &&
            queryClient.getQueryState(existingAgreementCheckKey(identity))?.status === 'success';
        setSeenKey(settled ? identityKey(vehicle) : null);
    };

    return {
        recordSelection,
        isSeen: seenKey !== null && seenKey === identityKey(selectedVehicle),
    };
}
